import {Id} from './basics'
import { mapDateFromApi } from 'src/core/utils'
import { mapPaginationFromApi } from './paginated'
import { IUser } from './user'

export interface IDocument {
    id?: Id;
    created_at: Date;
    owner_id: string;
    target_id?: string;
    target_type?: string;
    name: string;
    description?: string;
    content_type?: string;
    path: string;
    doc_type: string;
    folder_id?: string;
    locked: boolean;
    permalink?: string;
    tag?: string;
    custom?: object;
    category_document?: string;
    category_principale?: string;
    category_produit?: string;
    must_be_converted: boolean;
    must_be_signed: boolean;
    override_existing_file?: boolean;
    expire_at?: Date;
    external_url?: string;
}

export interface DocRecipient{
    id: Id;
    name: string;
    members?: IUser[];
    is_mandataire?: boolean;
    isSelected: boolean;
}

export enum DOCTYPE {
    DIR = "DIR",
    FILE = "FILE"
}
  
export const mapDocumentFromApi = (apiDocument: any): IDocument => ({
    ...apiDocument,
    created_at: mapDateFromApi(apiDocument.created_at),
    expire_at: mapDateFromApi(apiDocument.expire_at),
})

export const mapDocumentListFromApi = (apiDocuments: any): IDocument[] => {
    return apiDocuments.map(d => mapDocumentFromApi(d))
}

export const mapDocumentPaginationFromApi = mapPaginationFromApi<IDocument>(mapDocumentFromApi)

export const mapEnterpriseToDocRecipient = (apiEnterprise: any): DocRecipient => ({
    ...apiEnterprise,
    isSelected: true
})
  
export const mapEnterpriseListToDocRecipients = (apiEnterprise: any): DocRecipient[] => {
    return apiEnterprise.data.fundraise_searchs.data.map(d => mapEnterpriseToDocRecipient(d))
}



// WEBPACK FOOTER //
// ./src/type/document.ts